import { CompanyUser } from '../model/company-user';
export class CompanyUserBuilder {
    static buildCompanyUser(data) {
        let user = new CompanyUser();
        user.email = data.email;
        user.userId = data.user_id;
        user.name = data.name;
        user.lastName = data.lastname;
        user.phone = data.phone;
        user.zipCode = data.zipCode;
        user.password = data.password;
        user.block_premium_for_this_profile = data.block_premium_for_this_profile;
        user.invitationId = data.invitation_id;
        user.costCenterId = data.costcenter_id;
        user.costCenterName = data.costcenter_name;
        user.role = data.rights.role;
        user.profileId = data.profile_id;
        return user;
    }
    static buildCompanyUserPayload(user, newRecord) {
        let payload = {
            email: user.email,
            name: user.name ? user.name : null,
            lastname: user.lastName ? user.lastName : null,
            phone: user.phone ? user.phone : null,
            password: user.password ? user.password : null,
            costcenter_id: user.costCenterId,
            costcenter_name: user.costCenterName,
            block_premium_for_this_profile: user.block_premium_for_this_profile,
            rights: { role: user.role }
        };
        if (!newRecord) {
            payload.profile_id = user.profileId;
        }
        return payload;
    }
}
//# sourceMappingURL=company-user-builder.js.map